/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ saved: NonNullable<unknown>, failed: NonNullable<unknown> }} Sub_Quotas_Save_PartialInputs */



/**
* | output |
* | --- |
* | "Saved {saved}, failed {failed}." |
*
* @param {Sub_Quotas_Save_PartialInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_save_partial = /** @type {((inputs: Sub_Quotas_Save_PartialInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Save_PartialInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.saved} gespeichert, ${i?.failed} fehlgeschlagen.`)
	return /** @type {LocalizedString} */ (`Saved ${i?.saved}, failed ${i?.failed}.`)
});